module.exports = __webpack_public_path__ + "media/images/linkedin-white-98fb77fe.png";